import { Host, h } from "@stencil/core";
import { ButtonAppearance } from "../oh-button/oh-button.types";
import { ActionType } from "./oh-modal.types";
export class OhModal {
    constructor() {
        this.open = undefined;
        this.headline = undefined;
        this.subline = undefined;
        this.icon = undefined;
        this.actionDisabled = undefined;
        this.actionLoading = undefined;
        this.actionType = undefined;
        this.closeButtonLabel = undefined;
        this.actionButtonLabelLeft = undefined;
        this.actionButtonLabelRight = undefined;
        this.extendedWidth = false;
        this.reducedSlotMargin = false;
        this.isModalClicked = undefined;
    }
    handleOverlayMouseDown(e) {
        this.isModalClicked = e.target === this.overlayRef;
    }
    handleOverlayMouseUp(e) {
        if (e.target === this.overlayRef && this.isModalClicked && this.actionType !== ActionType.ACKNOWLEDGE) {
            this.close.emit();
        }
    }
    renderActions() {
        switch (this.actionType) {
            case ActionType.CONFIRM:
                return (h("div", { class: "modal__actions" }, h("div", { class: "modal__actions__column" }, h("oh-button", { text: this.actionButtonLabelRight, appearance: ButtonAppearance.CONTAINED_PRIMARY, onOhButtonClick: (e) => this.actionButtonRightClick.emit(e), disabled: this.actionDisabled, loading: this.actionLoading, fullWidth: true, parentComponent: this.element.tagName.toLowerCase() }))));
            case ActionType.CANCEL_CONFIRM:
                return (h("div", { class: "modal__actions" }, h("div", { class: "modal__actions__column" }, h("oh-button", { text: this.actionButtonLabelLeft, appearance: ButtonAppearance.TEXT, onOhButtonClick: (e) => this.actionButtonLeftClick.emit(e), parentComponent: this.element.tagName.toLowerCase() })), h("div", { class: "modal__actions__column" }, h("oh-button", { text: this.actionButtonLabelRight, appearance: ButtonAppearance.CONTAINED_PRIMARY, onOhButtonClick: (e) => this.actionButtonRightClick.emit(e), disabled: this.actionDisabled, loading: this.actionLoading, fullWidth: true, parentComponent: this.element.tagName.toLowerCase() }))));
            case ActionType.ACKNOWLEDGE:
                return (h("div", { class: "modal__actions" }, h("div", { class: "modal__actions__column right" }, h("oh-button", { text: this.actionButtonLabelRight, appearance: ButtonAppearance.CONTAINED_DARK, onOhButtonClick: (e) => this.actionButtonRightClick.emit(e), disabled: this.actionDisabled, loading: this.actionLoading, parentComponent: this.element.tagName.toLowerCase() }))));
            default:
                return null;
        }
    }
    render() {
        return (h(Host, { key: 'e0a7c7e1afb881e1822bee25a4884e5f0604c33c' }, h("div", { key: '3509ed4c17c6c036e3740778558567c1686a5b2c', class: { overlay: true, open: this.open }, ref: (el) => {
                this.overlayRef = el;
            }, onMouseDown: (e) => this.handleOverlayMouseDown(e), onMouseUp: (e) => this.handleOverlayMouseUp(e) }, h("div", { key: '5bce79539b78a46241c705c33431829784cfdec1', class: `modal__container ${this.extendedWidth ? 'extended-width' : ''}` }, h("oh-icon-button", { key: 'c243de1d102dc9849038b98ce7c0caf2420ffe94', icon: "x", ariaLabel: this.closeButtonLabel, class: "modal__close", onClick: () => {
                this.close.emit();
            }, parentComponent: this.element.tagName.toLowerCase() }), h("div", { key: '404091ac454e8797479234a0c6900826a632457b', class: "modal__content" }, this.icon && h("oh-icon", { key: '514aa68010cf840065ab53b6863b47553228945e', name: this.icon, size: 48 }), this.headline && h("h3", { key: 'aae550074b1d7b6f62d3218f489f85b8992c9a34' }, this.headline), this.subline && h("p", { key: '4f2bbb9b08b3d67674c13a185ea2172ae6e9cb20', innerHTML: this.subline })), h("div", { key: '58986db499116ee092295f5de051c7bb462b050f', class: `modal__slot ${this.reducedSlotMargin ? 'reduced-margin' : ''}` }, h("slot", { key: '2e686c26cbc0be8b2a09649ad90f4fa5b6af0bf9' })), this.renderActions()))));
    }
    static get is() { return "oh-modal"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["oh-modal.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["oh-modal.css"]
        };
    }
    static get properties() {
        return {
            "open": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "open",
                "reflect": false
            },
            "headline": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "headline",
                "reflect": false
            },
            "subline": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "subline",
                "reflect": false
            },
            "icon": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "icon",
                "reflect": false
            },
            "actionDisabled": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "action-disabled",
                "reflect": false
            },
            "actionLoading": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "action-loading",
                "reflect": false
            },
            "actionType": {
                "type": "number",
                "mutable": false,
                "complexType": {
                    "original": "ActionType",
                    "resolved": "ActionType.ACKNOWLEDGE | ActionType.CANCEL_CONFIRM | ActionType.CONFIRM | ActionType.NONE",
                    "references": {
                        "ActionType": {
                            "location": "import",
                            "path": "./oh-modal.types",
                            "id": "src/components/oh-modal/oh-modal.types.ts::ActionType"
                        }
                    }
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "action-type",
                "reflect": false
            },
            "closeButtonLabel": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "close-button-label",
                "reflect": false
            },
            "actionButtonLabelLeft": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "action-button-label-left",
                "reflect": false
            },
            "actionButtonLabelRight": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "action-button-label-right",
                "reflect": false
            },
            "extendedWidth": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "extended-width",
                "reflect": false,
                "defaultValue": "false"
            },
            "reducedSlotMargin": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "reduced-slot-margin",
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
    static get states() {
        return {
            "isModalClicked": {}
        };
    }
    static get events() {
        return [{
                "method": "actionButtonLeftClick",
                "name": "actionButtonLeftClick",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }, {
                "method": "actionButtonRightClick",
                "name": "actionButtonRightClick",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }, {
                "method": "close",
                "name": "close",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }];
    }
    static get elementRef() { return "element"; }
}
//# sourceMappingURL=oh-modal.js.map
